// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    MIC_2020_YEAR_PAGE_LOADING() {
      return {
        isLoading: true,
        mic2020YearPage: {} // action.micYearPage
      };
    },
    MIC_2020_YEAR_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastmic';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'most-innovative-companies',
        'categoryPage'
      );

      // Override this for MCP
      adModelData.model.adzone = 'leadership/most-innovative-companies';
      return {
        isLoading: false,
        data: {}, // action.micYearPage,
        ads: adModelData
      };
    },
    MIC_2020_YEAR_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mic2020YearPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
